export enum FormListFormDropownOptionsConfig {
  AllForms = 1,
  OnlyFormsWithSubmissions = 2
}